<ng-container>
  <div>
    <div *ngIf="embedDetails?.allowPrintOnDemand && !(app.loadingStatus | async).isLoading && !showButtons" style="width:100%">
      <div class="row" style="margin-right: 0px">
        <div class="col-md-11"></div>
        <div class="col-md-1" style="justify-content: right; padding-top: 5px">
          <a href="#" (click)="printOnDemand()">
            <span class="fa fa-print" title="Print Report"></span>
          </a>
        </div>
      </div>
    </div>
    <div *ngIf="showButtons" style="width:100%">
      <div class="row" style="margin-right: 0px">
        <div class="col-md-1"></div>
        <div class="col-md-1" style="justify-content: center">
          <br />
          <ng-container *ngIf="isFirstPage() && !loadingReport">
            <i class="fa fa-arrow-left"></i><span>&nbsp;Prev Page</span>
          </ng-container>
          <ng-container *ngIf="!isFirstPage() && !loadingReport">
            <a href="#" style="text-decoration: none; color: white" (click)="movePrevPage()">
             <i class="fa fa-arrow-left"></i><span>&nbsp;Prev Page</span>
            </a>
          </ng-container>
        </div>
        <div class="col-md-1" style="justify-content: center">
          <br />
          <ng-container *ngIf="isLastPage() && !loadingReport">
            <span>Next Page&nbsp;</span><i class="fa fa-arrow-right"></i>
          </ng-container>
          <ng-container *ngIf="!isLastPage() && !loadingReport">
            <a href="#" style="text-decoration: none; color: white" (click)="moveNextPage()">
              <span>Next Page&nbsp;</span><i class="fa fa-arrow-right"></i>
            </a>
          </ng-container>
        </div>
        <div class="col-md-1"></div>
        <div class="col-md-4" style="text-align: center; justify-content: center;">
          <h2 *ngIf="!loadingReport" style="color: white; font-weight: bolder">{{ getFilterPageName() }}</h2>
        </div>
        <div class="col-md-4"  style="justify-content: center">
          <button mat-raised-button class="piButton" (click)="editLayoutProperites()">Edit Properties</button>
          <button mat-raised-button class="piButton" (click)="save()">Save Layout</button>
          <button mat-raised-button class="piButton" (click)="closeLinkClicked()">Cancel</button>
        </div>
      </div>
    </div>
    <div [style]="loadingStyle()">
      <div>
        <div class="col-md-2"></div>
      </div>
      <div *ngIf="hasHeader()" style="width: 100%; height: 100px;">
        <img [src]="headerImageSrc" style="width: 100%" height="100" />
      </div>
      <div class="ditch-pbi-border" [style]="getBackgroundColor()">
        <div #pbiContainer class="displayNormal" [style]="getPbiStyleHeight()"></div>
      </div>
      <div *ngIf="hasFooter()" style="width: 100%; height: 100px;">
        <img [src]="footerImageSrc" style="width:100%" height="100" />
      </div>
     </div>
  </div>
</ng-container>
